import { Injectable } from '@angular/core';
import { delay, of, type Observable } from 'rxjs';

import type { EmailResponseClient } from '../tokens/email-response-client.token';
import type {
  EmailResponseForm,
  SubmitEmailResponsePayload,
} from '../../features/email-response/models/email-response.model';

@Injectable({ providedIn: 'root' })
export class EmailResponseMockService implements EmailResponseClient {
  getEmailResponseForm(incidentNumber: string): Observable<EmailResponseForm> {
    const responded = isMockResponded(incidentNumber);

    return of({
      incidentNumber,
      incidentId: mockIncidentId(incidentNumber),
      medicationName: 'OXYCODONE',
      employeeName: 'LisaEvm',
      employeeId: 'LEV10',
      hasResponded: responded,
      respondedAt: responded ? new Date('2025-02-13T08:16:00Z').toISOString() : null,
    } satisfies EmailResponseForm).pipe(delay(300));
  }

  submitEmailResponse(
    incidentNumber: string,
    _payload: SubmitEmailResponsePayload
  ): Observable<void> {
    // Mock as success.
    return of(void 0).pipe(delay(300));
  }
}

function isMockResponded(incidentNumber: string): boolean {
  // Deterministic for easy testing: even numbers render "already responded".
  const asNumber = Number.parseInt(incidentNumber, 10);
  if (Number.isFinite(asNumber)) {
    return asNumber % 2 === 0;
  }
  return incidentNumber.toLowerCase().includes('responded');
}

function mockIncidentId(incidentNumber: string): number {
  const asNumber = Number.parseInt(incidentNumber, 10);
  if (Number.isFinite(asNumber)) {
    return asNumber;
  }
  // Deterministic id from string (e.g. guid) for mock
  return Math.abs(
    incidentNumber.split('').reduce((acc, c) => acc + c.charCodeAt(0), 0) % 100000
  ) || 1;
}

